// extracted by mini-css-extract-plugin
module.exports = {"root":"KYC_root__oJy4j"};